import { render, staticRenderFns } from "./SubcontractorExpensesMaterialsAdd.vue?vue&type=template&id=380aa9c6&scoped=true&"
import script from "./SubcontractorExpensesMaterialsAdd.vue?vue&type=script&lang=js&"
export * from "./SubcontractorExpensesMaterialsAdd.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractorExpensesMaterialsAdd.vue?vue&type=style&index=0&id=380aa9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380aa9c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
